import UiElement from '../../../shared/ui-element/ui-element';

class SignupFormStepSpeciality extends UiElement {
  ui = {
    submitButton: '.js-speciality-form-step-submit',
  };

  uiCollections = {
    bundleInputs: '.signup-form__speciality-card-input',
    bundles: '.signup-form__speciality-card',
  };

  events = {
    'submit @rootElement': 'handleFormStepSubmit',
    'click @uiCollections.bundleInputs': 'handleBundlesClick',
  };

  constructor(options = {}) {
    super({rootElement: '#signup-form-step-speciality'});

    this.onSubmit = options.onSubmit;
  }

  handleFormStepSubmit(e) {
    e.preventDefault();
    const checkedBundle = document.querySelector('.signup-form__speciality-card-input:checked');

    const bundleId = checkedBundle ? checkedBundle.id : null;

    this.onSubmit({bundleId});
  }

  handleBundlesClick(e) {
    const siblingInputs = [...this.uiCollections.bundleInputs].filter(c => c !== e.target);
    siblingInputs.forEach(this.uncheckOtherBundles);
    if (e.target.checked) {
      this.ui.submitButton.classList.add('signup-form__speciality-submit', 'btn_primary');
      this.ui.submitButton.classList.remove('btn_outline-primary');
      e.target.closest('.signup-form__speciality-card').classList.add('signup-form__speciality-card-active');
    } else {
      this.ui.submitButton.classList.remove('signup-form__speciality-submit', 'btn_primary');
      this.ui.submitButton.classList.add('btn_outline-primary');
      e.target.closest('.signup-form__speciality-card').classList.remove('signup-form__speciality-card-active');
    }
  }

  uncheckOtherBundles(bundle) {
    // eslint-disable-next-line no-param-reassign
    bundle.checked = false;
    bundle.closest('.signup-form__speciality-card').classList.remove('signup-form__speciality-card-active');
  }
}

export default SignupFormStepSpeciality;
